import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-40bf693c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-[#141a24] border border-gray-700 rounded-xl shadow-2xl w-full max-w-md overflow-hidden" }
const _hoisted_2 = { class: "px-5 py-4 border-b border-gray-700 flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-white font-semibold text-base" }, "Ouvrir une caisse", -1))
const _hoisted_4 = { class: "p-5 space-y-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, " Saisissez le fond de caisse physique remis à la prise de service. Ce montant servira de base pour calculer l'écart en fin de journée. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block text-[11px] font-medium uppercase tracking-wider text-gray-500 mb-1" }, " Fond de caisse (FCFA) ", -1))
const _hoisted_7 = {
  key: 0,
  class: "mt-1 text-[11px] text-gray-500"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block text-[11px] font-medium uppercase tracking-wider text-gray-500 mb-1" }, " Commentaire (optionnel) ", -1))
const _hoisted_9 = { class: "px-5 py-3 bg-black/20 border-t border-gray-700 flex justify-end gap-2" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]

import { ref } from "vue";
	import useCashierSession from "@/composable/useCashierSession";
	import useNotyf from "@/composable/useNotyf";
	import useFormatMoney from "@/composable/useFormatMoney";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'OpenCashierSessionModal',
  props: {
    open: { type: Boolean }
  },
  emits: ["close", "opened"],
  setup(__props: any, { emit: __emit }) {

	/**
	 * Modal d'ouverture de session de caisse. Saisie du fond initial.
	 * Émet `opened` sur succès.
	 */
	const props = __props;
	const emit = __emit;

	const notify = useNotyf();
	const { openSession } = useCashierSession();

	const openingFloat = ref<number | null>(null);
	const notes = ref("");
	const isSubmitting = ref(false);

	const submit = async () => {
		if (openingFloat.value == null || openingFloat.value < 0) {
			notify.error("Veuillez saisir un fond de caisse (0 ou positif)");
			return;
		}
		isSubmitting.value = true;
		try {
			await openSession({
				opening_float: Number(openingFloat.value),
				notes: notes.value || undefined,
			});
			notify.success("Caisse ouverte");
			openingFloat.value = null;
			notes.value = "";
			emit("opened");
			emit("close");
		} catch (err: any) {
			const code = err?.status;
			if (code === 409) {
				notify.error("Une session est déjà ouverte sur cette agence");
				emit("close");
			} else {
				notify.error(err?.data?.response?.message || "Erreur à l'ouverture");
			}
		}
		isSubmitting.value = false;
	};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_ctx.open)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 bg-black/60 z-[60] flex items-center justify-center p-4",
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (emit('close')), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("header", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close'))),
                  class: "text-gray-400 hover:text-white text-xl leading-none"
                }, " × ")
              ]),
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", null, [
                  _hoisted_6,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((openingFloat).value = $event)),
                    type: "number",
                    min: "0",
                    step: "100",
                    placeholder: "0",
                    class: "w-full px-3 py-2 rounded bg-[#0D181C] border border-gray-700 text-white tabular-nums focus:outline-none focus:border-accent"
                  }, null, 512), [
                    [
                      _vModelText,
                      openingFloat.value,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  (openingFloat.value != null && openingFloat.value > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(useFormatMoney)(openingFloat.value)) + " FCFA ", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_8,
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((notes).value = $event)),
                    rows: "2",
                    placeholder: "Ex : reprise sur fond précédent, dépannage…",
                    class: "w-full px-3 py-2 rounded bg-[#0D181C] border border-gray-700 text-white text-sm focus:outline-none focus:border-accent"
                  }, null, 512), [
                    [_vModelText, notes.value]
                  ])
                ])
              ]),
              _createElementVNode("footer", _hoisted_9, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('close'))),
                  disabled: isSubmitting.value,
                  class: "px-4 py-1.5 text-sm text-gray-300 bg-transparent border border-gray-600 rounded hover:bg-gray-700 disabled:opacity-50"
                }, " Annuler ", 8, _hoisted_10),
                _createElementVNode("button", {
                  type: "button",
                  onClick: submit,
                  disabled: isSubmitting.value || openingFloat.value == null,
                  class: "px-4 py-1.5 text-sm text-white bg-[#219152] rounded hover:bg-[#167841] disabled:bg-gray-600 disabled:opacity-60"
                }, _toDisplayString(isSubmitting.value ? "Ouverture…" : "Ouvrir la caisse"), 9, _hoisted_11)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})